import React from 'react';
import {
  initializeCollection,
  PagedCollectionProvider,
  usePagedCollectionDispatch,
  usePagedCollectionState,
} from 'Context/PagedCollectionContext';

const StateContext = React.createContext(undefined);
const DispatchContext = React.createContext(undefined);

const ManagedAccountStatementDocumentsContextProvider = ({
  statementDocumentsSelfLink,
  ...rest
}) => {
  if (!statementDocumentsSelfLink) {
    const { children } = rest;
    return children;
  }

  return (
    <PagedCollectionProvider
      StateContext={StateContext}
      DispatchContext={DispatchContext}
      initialState={{
        collectionSelfLink: statementDocumentsSelfLink,
      }}
      {...rest}
    />
  );
};

const initializeManagedAccountStatementDocumentsCollection = (dispatch, linkUrl) => {
  initializeCollection(dispatch, linkUrl);
};

const useManagedAccountStatementDocumentsDispatchContext = () => {
  const context = usePagedCollectionDispatch(DispatchContext);

  if (!context) throw new Error('useManagedAccountStatementDocumentsDispatchContext must be called from DispatchContext.Provider');

  return context;
};

const useManagedAccountStatementDocumentsStateContext = () => {
  const context = usePagedCollectionState(StateContext);

  if (!context) throw new Error('useManagedAccountStatementDocumentsDispatchContext must be called from StateContext.Provider');

  return context;
};

export {
  ManagedAccountStatementDocumentsContextProvider,
  useManagedAccountStatementDocumentsDispatchContext,
  useManagedAccountStatementDocumentsStateContext,
  initializeManagedAccountStatementDocumentsCollection,
};
